import styled from "@emotion/styled";
import { SocialButtonProps } from "./SocialButton.types";
import { generateSocialButtonStyles } from "../../utils";
import { colorGuide } from "../../theme/colors";
import isPropValid from "@emotion/is-prop-valid";

// Main container for the social button
export const SocialButtonContainer = styled("div", {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && prop !== "disabled" && prop !== "variant",
})<SocialButtonProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  border-radius: 8px;
  padding: 4px 16px;
  color: ${colorGuide.lightComponents.socialButton.color};
  border: none;
  background: transparent;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
  ${(props) => generateSocialButtonStyles(props)};
`;

export const SocialIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  padding: 10px;
`;

export const SocialIcon = styled.i`
  font-size: 20px;
`;

export const RightArrowIcon = styled.i`
  font-size: 8px;
`;

export const SocialButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
